import type { HeadingProps } from '../heading'

import { useStyleConfig, vui } from '../core'
import Heading from '../heading'
import { cs } from '../utils'
import { useFooterContext } from './context'

/** Heading of a links section. */
export const FooterHeading = vui<'h5', HeadingProps>((props, ref) => {
  const { className, ...rest } = props
  const styles = useStyleConfig('Footer', useFooterContext())

  return (
    <Heading
      className={cs('vui-footerHeading', className)}
      color="white"
      mb={1}
      ref={ref}
      size="h5"
      {...styles.heading}
      {...rest}
    />
  )
})

FooterHeading.displayName = 'FooterHeading'
export default FooterHeading
